import { Link } from "react-router-dom";
import { Shield, Phone, Mail, MapPin } from "lucide-react";
import { Button } from "./ui/button";

export const Footer = () => {
  const serviceStates = ["MN", "WI", "IA", "ND", "SD", "TN", "AZ"];

  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white">
      {/* Call to Action Section */}
      <div className="bg-primary py-12">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-2">
                Ready to Protect What Matters Most?
              </h3>
              <p className="text-blue-100 text-lg">
                Reach out to our office for a personalized insurance consultation
              </p>
            </div>
            <Link to="/contact">
              <Button
                size="lg"
                variant="secondary"
                className="bg-white text-primary hover:bg-gray-100 font-semibold px-8 py-6 text-lg whitespace-nowrap"
              >
                Schedule Consultation
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/2nyjkvgp_HTW%20Logo.png"
                alt="Henry T. Warner Co. Logo"
                className="h-20 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Independent insurance professionals providing comprehensive coverage solutions across multiple states.
            </p>
            <div className="flex flex-wrap gap-2">
              {serviceStates.map((state) => (
                <span
                  key={state}
                  className="px-3 py-1 bg-slate-700 text-blue-200 rounded-full text-sm font-medium"
                >
                  {state}
                </span>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-primary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-primary transition-colors">
                  Get a Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Insurance Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Insurance Services</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/personal-insurance"
                  className="text-gray-300 hover:text-primary transition-colors"
                >
                  Personal Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/commercial-insurance"
                  className="text-gray-300 hover:text-primary transition-colors"
                >
                  Commercial Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/life-insurance-annuities"
                  className="text-gray-300 hover:text-primary transition-colors"
                >
                  Life Insurance & Annuities
                </Link>
              </li>
              <li>
                <Link
                  to="/industry-partners"
                  className="text-gray-300 hover:text-primary transition-colors"
                >
                  Industry Partners
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">Call us today</p>
                  <a href="tel:+19529389190" className="text-white hover:text-primary transition-colors">
                    (952) 938-9190
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">Email us</p>
                  <a
                    href="mailto:Justin.Schneider@Comcast.net"
                    className="text-white hover:text-primary transition-colors break-all"
                  >
                    Justin.Schneider@Comcast.net
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">Fax</p>
                  <a href="tel:+19524446191" className="text-white hover:text-primary transition-colors">
                    (952) 444-6191
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">Serving 7 states</p>
                  <p className="text-white">MN, WI, IA, ND, SD, TN, AZ</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Henry T. Warner Co. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
